"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHOW_IN_FORM = exports.HIDE_IN_FORM = exports.SHOW_IN_TABLE = exports.HIDE_IN_TABLE = void 0;
exports.HIDE_IN_TABLE = {
    table: {
        hide: true,
    },
};
exports.SHOW_IN_TABLE = {
    table: {
        hide: false,
    },
};
exports.HIDE_IN_FORM = {
    form: {
        hide: true,
    },
};
exports.SHOW_IN_FORM = {
    form: {
        hide: false,
    },
};
//# sourceMappingURL=layouts.js.map